import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, usedFileType, loadOptions, note, uploadTrigger }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden,
    usedFileType,
    loadOptions,
    note,
    uploadTrigger
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
      aboutAndLegal: mapFields(data?.aboutAndLegal),
      mainMenu: mapFields(data?.mainMenu),
      childMenus: mapFields(data?.childMenus),
      grandChildMenus: mapFields(data?.grandChildMenus),
      servicePortals: mapFields(data?.servicePortals),
      socialMedia: mapFields(data?.socialMedia)
    };
    resolve(fields); 
  } catch (error) {
    reject(error); 
  }
});

export { fields, fieldsReady };
